export interface InspirationIdea {
  id: string;
  category: InspirationCategory;
  photoUrl: string;
  title: string;
  description?: string;
  weekday?: number;
}

export enum InspirationCategory {
  BD = 'Birthdays',
  BK = 'Kids\' Birthdays',
  BF = 'Bonfire',
  BP = 'Book Party',
  BS = 'Baby Shower',
  CK = 'Cocktail Party',
  CP = 'Costume Party',
  DP = 'Dessert Party',
  GD = 'Garden Party',
  GN = 'Games Night',
  GP = 'Graduation Party',
  HH = 'Happy Hour',
  HO = 'Holidays',
  HP = 'Holiday Party',
  HW = 'Housewarming',
  MC = 'Miscellaneous',
  MN = 'Movie Night',
  MS = 'Miscellaneous',
  PP = 'Pizza Party',
  SE = 'Sporting Event',
  SP = 'Super Bowl Party',
  TP = 'Tea Party',
  WD = 'Wedding Shower or Brunch',
  WT = 'Wine Tasting'
}

const IC = InspirationCategory;
const Inspirations: InspirationIdea[] = [
    {
      id: '1',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBirthday_Bash.jpg?alt=media',
      title: 'Birthday Bash'
    },
    {
      id: '2',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBirthday_Party_Time.jpg?alt=media',
      title: 'Birthday Party Time'
    },
    {
      id: '124',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPainterly_Birthday.jpg?alt=media',
      title: 'Painterly Birthday'
    },
    {
      id: '3',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRainbow_Birthday.jpg?alt=media',
      title: 'Rainbow Birthday'
    },
    {
      id: '4',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRainbows_Galore_Birthday.jpg?alt=media',
      title: 'Rainbows Galore Birthday'
    },
    {
      id: '125',
      category: IC.BD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FShiny_Presents.jpg?alt=media',
      title: 'Shiny Presents'
    },
    {
      id: '5',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBeach_Bonfire.jpg?alt=media',
      title: 'Beach Bonfire'
    },
    {
      id: '126',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCampfire_in_the_Forest.jpg?alt=media',
      title: 'Campfire in the Forest'
    },
    {
      id: '6',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCampout.jpg?alt=media',
      title: 'Campout'
    },
    {
      id: '7',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPainterly_Bonfire.jpg?alt=media',
      title: 'Painterly Bonfire'
    },
    {
      id: '8',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FS_mores_Party.jpg?alt=media',
      title: 'S\'mores Party'
    },
    {
      id: '9',
      category: IC.BF,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSurfer_Beach_Party.jpg?alt=media',
      title: 'Surfer Beach Party'
    },
    {
      id: '10',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBounce_Birthday.jpg?alt=media',
      title: 'Bounce Birthday'
    },
    {
      id: '11',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDinosaur_Birthday.jpg?alt=media',
      title: 'Dinosaur Birthday'
    },
    {
      id: '12',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFairytale_Birthday.jpg?alt=media',
      title: 'Fairytale Birthday'
    },
    {
      id: '13',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLego_Birthday.jpg?alt=media',
      title: 'Lego Birthday'
    },
    {
      id: '14',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMermaid_Birthday.jpg?alt=media',
      title: 'Mermaid Birthday'
    },
    {
      id: '15',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMythical_Dragon_Birthday.jpg?alt=media',
      title: 'Mythical Dragon Birthday'
    },
    {
      id: '16',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FNerf_Party.jpg?alt=media',
      title: 'Nerf Party'
    },
    {
      id: '17',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FUnicorn_Birthday.jpg?alt=media',
      title: 'Unicorn Birthday'
    },
    {
      id: '18',
      category: IC.BK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FWet_and_Wild_Birthday.jpg?alt=media',
      title: 'Wet and Wild Birthday'
    },
    {
      id: '127',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBooks__Books__and_More_Books.jpg?alt=media',
      title: 'Books, Books and More Books'
    },
    {
      id: '19',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDazzle_of_Books.jpg?alt=media',
      title: 'Dazzle of Books'
    },
    {
      id: '20',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFlying_Books.jpg?alt=media',
      title: 'Flying Books'
    },
    {
      id: '21',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFountain_Pen.jpg?alt=media',
      title: 'Fountain Pen'
    },
    {
      id: '22',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGilded_Library.jpg?alt=media',
      title: 'Gilded Library'
    },
    {
      id: '23',
      category: IC.BP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLibrary_of_Academia.jpg?alt=media',
      title: 'Library of Academia'
    },
    {
      id: '128',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGender_Reveal.jpg?alt=media',
      title: 'Gender Reveal'
    },
    {
      id: '24',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGroovy_Baby_Shower.jpg?alt=media',
      title: 'Groovy Baby Shower'
    },
    {
      id: '25',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMod_Baby_Shower.jpg?alt=media',
      title: 'Mod Baby Shower'
    },
    {
      id: '26',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPastel_Baby_Shower.jpg?alt=media',
      title: 'Pastel Baby Shower'
    },
    {
      id: '27',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSurreal_Baby_Shower.jpg?alt=media',
      title: 'Surreal Baby Shower'
    },
    {
      id: '28',
      category: IC.BS,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FZoo_licious_Baby_Shower.jpg?alt=media',
      title: 'Zoo-licious Baby Shower'
    },
    {
      id: '29',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCocktail_Swirls.jpg?alt=media',
      title: 'Cocktail Swirls'
    },
    {
      id: '30',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCocktails_in_NYC.jpg?alt=media',
      title: 'Cocktails in NYC'
    },
    {
      id: '129',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFruity_Cocktail.jpg?alt=media',
      title: 'Fruity Cocktail'
    },
    {
      id: '31',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGuys_Night.jpg?alt=media',
      title: 'Guys Night'
    },
    {
      id: '32',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRooftop_Cocktail.jpg?alt=media',
      title: 'Rooftop Cocktail'
    },
    {
      id: '33',
      category: IC.CK,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FTropical_Cocktails.jpg?alt=media',
      title: 'Tropical Cocktails'
    },
    {
      id: '34',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2F80s.jpg?alt=media',
      title: '80s'
    },
    {
      id: '35',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCostume_Closet.jpg?alt=media',
      title: 'Costume Closet'
    },
    {
      id: '36',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDisco.jpg?alt=media',
      title: 'Disco'
    },
    {
      id: '37',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDress_As_Your_Pet_Party.jpg?alt=media',
      title: 'Dress As Your Pet Party'
    },
    {
      id: '130',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDress_Like_a_Pirate_Party.jpg?alt=media',
      title: 'Dress Like a Pirate Party'
    },
    {
      id: '38',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGreat_Gatsby.jpg?alt=media',
      title: 'Great Gatsby'
    },
    {
      id: '39',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMasks_and_Jewels.jpg?alt=media',
      title: 'Masks and Jewels'
    },
    {
      id: '40',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMasquerade.jpg?alt=media',
      title: 'Masquerade'
    },
    {
      id: '41',
      category: IC.CP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRegal_Renaissance.jpg?alt=media',
      title: 'Regal Renaissance'
    },
    {
      id: '42',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBanana_Splits.jpg?alt=media',
      title: 'Banana Splits'
    },
    {
      id: '43',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDonuts_.jpg?alt=media',
      title: 'Donuts!'
    },
    {
      id: '44',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHow_Sweet_It_Is.jpg?alt=media',
      title: 'How Sweet It Is'
    },
    {
      id: '46',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSugar_Tooth.jpg?alt=media',
      title: 'Sugar Tooth'
    },
    {
      id: '47',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSundae_Party.jpg?alt=media',
      title: 'Sundae Party'
    },
    {
      id: '48',
      category: IC.DP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSundae_Special.jpg?alt=media',
      title: 'Sundae Special'
    },
    {
      id: '131',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FColorful_Flowers.jpg?alt=media',
      title: 'Colorful Flowers'
    },
    {
      id: '49',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFlower_Path.jpg?alt=media',
      title: 'Flower Path'
    },
    {
      id: '132',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGarden_Vegetables.jpg?alt=media',
      title: 'Garden Vegetables'
    },
    {
      id: '50',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPicnic_Art.jpg?alt=media',
      title: 'Picnic Art'
    },
    {
      id: '51',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPop_Art_Tulips.jpg?alt=media',
      title: 'Pop Art Tulips'
    },
    {
      id: '52',
      category: IC.GD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSecret_Garden.jpg?alt=media',
      title: 'Secret Garden'
    },
    {
      id: '53',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FChess_Cartoon.jpg?alt=media',
      title: 'Chess Cartoon'
    },
    {
      id: '133',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FClassic_Games.jpg?alt=media',
      title: 'Classic Games'
    },
    {
      id: '54',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCubist_Cards.jpg?alt=media',
      title: 'Cubist Cards'
    },
    {
      id: '55',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGames_Galore.jpg?alt=media',
      title: 'Games Galore'
    },
    {
      id: '56',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPoker_Chips.jpg?alt=media',
      title: 'Poker Chips'
    },
    {
      id: '57',
      category: IC.GN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FStellar_Chess.jpg?alt=media',
      title: 'Stellar Chess'
    },
    {
      id: '134',
      category: IC.GP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FThe_Graduate.jpg?alt=media',
      title: 'The Graduate'
    },
    {
      id: '58',
      category: IC.GP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGraduation_Party.jpg?alt=media',
      title: 'Graduation Party'
    },
    {
      id: '59',
      category: IC.GP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHats_Off.jpg?alt=media',
      title: 'Hats Off'
    },
    {
      id: '60',
      category: IC.HH,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBeers__Cheers.jpg?alt=media',
      title: 'Beers, Cheers'
    },
    {
      id: '61',
      category: IC.HH,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FChampagne_Toast.jpg?alt=media',
      title: 'Champagne Toast'
    },
    {
      id: '135',
      category: IC.HH,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPub_Happy_Hour.jpg?alt=media',
      title: 'Pub Happy Hour'
    },
    {
      id: '62',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBBQ_Pool_Party.jpg?alt=media',
      title: 'BBQ Pool Party'
    },
    {
      id: '63',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBlack_and_White_Haunted_House.jpg?alt=media',
      title: 'Black and White Haunted House'
    },
    {
      id: '64',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FEaster_Basket.jpg?alt=media',
      title: 'Easter Basket'
    },
    {
      id: '65',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FEaster_Eggs.jpg?alt=media',
      title: 'Easter Eggs'
    },
    {
      id: '66',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFlag_and_Fireworks.jpg?alt=media',
      title: 'Flag and Fireworks'
    },
    {
      id: '67',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFull_Moon_and_Jack_o_Lanterns.jpg?alt=media',
      title: 'Full Moon and Jack-o-Lanterns'
    },
    {
      id: '68',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGraphic_Fourth_of_July.jpg?alt=media',
      title: 'Graphic Fourth of July'
    },
    {
      id: '69',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHalloween_Confetti.jpg?alt=media',
      title: 'Halloween Confetti'
    },
    {
      id: '70',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHalloween_Silhouette_.jpg?alt=media',
      title: 'Halloween Silhouette '
    },
    {
      id: '71',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHalloween_Swirls.jpg?alt=media',
      title: 'Halloween Swirls'
    },
    {
      id: '72',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHaunted_House.jpg?alt=media',
      title: 'Haunted House'
    },
    {
      id: '73',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLunch_by_the_Pool.jpg?alt=media',
      title: 'Lunch by the Pool'
    },
    {
      id: '74',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMagic_Easter_Eggs.jpg?alt=media',
      title: 'Magic Easter Eggs'
    },
    {
      id: '75',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRed__White_and_Blue_Fireworks.jpg?alt=media',
      title: 'Red, White and Blue Fireworks'
    },
    {
      id: '76',
      category: IC.HO,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FVery_Spooky.jpg?alt=media',
      title: 'Very Spooky'
    },
    {
      id: '77',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FIce_Skating_with_Friends.jpg?alt=media',
      title: 'Ice Skating with Friends'
    },
    {
      id: '78',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPainterly_Skating.jpg?alt=media',
      title: 'Painterly Skating'
    },
    {
      id: '79',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPolar_Express.jpg?alt=media',
      title: 'Polar Express'
    },
    {
      id: '80',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSantas__Santas__and_More_Santas.jpg?alt=media',
      title: 'Santas, Santas, and More Santas'
    },
    {
      id: '81',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FUgly_Christmas_Sweaters.jpg?alt=media',
      title: 'Ugly Christmas Sweaters'
    },
    {
      id: '82',
      category: IC.HP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FVelvet_Christmas.jpg?alt=media',
      title: 'Velvet Christmas'
    },
    {
      id: '83',
      category: IC.HW,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FModern_Housewarming.jpg?alt=media',
      title: 'Modern Housewarming'
    },
    {
      id: '84',
      category: IC.HW,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMoving_Day.jpg?alt=media',
      title: 'Moving Day'
    },
    {
      id: '85',
      category: IC.HW,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMoving_Truck_Overflowing.jpg?alt=media',
      title: 'Moving Truck Overflowing'
    },
    {
      id: '86',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBowling_Party.jpg?alt=media',
      title: 'Bowling Party'
    },
    {
      id: '87',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGet_Your_Glow_On.jpg?alt=media',
      title: 'Get Your Glow On'
    },
    {
      id: '88',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FGive__em_Something_to_TACO__Bout.jpg?alt=media',
      title: 'Give \'em Something to TACO \'Bout'
    },
    {
      id: '89',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FIce_Skating_Party.jpg?alt=media',
      title: 'Ice Skating Party'
    },
    {
      id: '90',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FKite_Flying.jpg?alt=media',
      title: 'Kite Flying'
    },
    {
      id: '91',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLadies_Night.jpg?alt=media',
      title: 'Ladies Night'
    },
    {
      id: '92',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLet_s_Glow.jpg?alt=media',
      title: 'Let\'s Glow'
    },
    {
      id: '93',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLet_s_Go_Fly_a_Kite.jpg?alt=media',
      title: 'Let\'s Go Fly a Kite'
    },
    {
      id: '94',
      category: IC.MC,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRomance_and_Mystique.jpg?alt=media',
      title: 'Romance and Mystique'
    },
    {
      id: '95',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FDrive_In.jpg?alt=media',
      title: 'Drive-In'
    },
    {
      id: '96',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FHollywood_Golden.jpg?alt=media',
      title: 'Hollywood Golden'
    },
    {
      id: '97',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FLights._Camera._Action_.jpg?alt=media',
      title: 'Lights. Camera. Action!'
    },
    {
      id: '98',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FMovie_Night.jpg?alt=media',
      title: 'Movie Night'
    },
    {
      id: '99',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FOld_Fashioned_Film.jpg?alt=media',
      title: 'Old-Fashioned Film'
    },
    {
      id: '100',
      category: IC.MN,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPopcorn_and_Candy.jpg?alt=media',
      title: 'Popcorn and Candy'
    },
    {
      id: '137',
      category: IC.PP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FThe_Last_Supper.jpg?alt=media',
      title: 'The Last Supper'
    },
    {
      id: '45',
      category: IC.PP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPizza_Party.jpg?alt=media',
      title: 'Pizza Party'
    },
    {
      id: '136',
      category: IC.PP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FStreets_Lined_with_Pizza.jpg?alt=media',
      title: 'Streets Lined with Pizza'
    },
    {
      id: '101',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBaseball_Stadium_of_Baseballs.jpg?alt=media',
      title: 'Baseball Stadium of Baseballs'
    },
    {
      id: '102',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBaseball_Universe.jpg?alt=media',
      title: 'Baseball Universe'
    },
    {
      id: '103',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBasketball_Stars.jpg?alt=media',
      title: 'Basketball Stars'
    },
    {
      id: '104',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFriday_Night_Lights.jpg?alt=media',
      title: 'Friday Night Lights'
    },
    {
      id: '105',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSoccer_World.jpg?alt=media',
      title: 'Soccer World'
    },
    {
      id: '106',
      category: IC.SE,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSwirling_Soccer_Balls.jpg?alt=media',
      title: 'Swirling Soccer Balls'
    },
    {
      id: '107',
      category: IC.SP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFootball_Player_Art_.jpg?alt=media',
      title: 'Football Player Art '
    },
    {
      id: '108',
      category: IC.SP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFootball_Rocket.jpg?alt=media',
      title: 'Football Rocket'
    },
    {
      id: '109',
      category: IC.SP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FStadium_Game.jpg?alt=media',
      title: 'Stadium Game'
    },
    {
      id: '110',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCitrus_Tea.jpg?alt=media',
      title: 'Citrus Tea'
    },
    {
      id: '111',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFairy_Creature_Tea.jpg?alt=media',
      title: 'Fairy Creature Tea'
    },
    {
      id: '112',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPainted_Garden.jpg?alt=media',
      title: 'Painted Garden'
    },
    {
      id: '113',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FTea_and_food_and_flowers.jpg?alt=media',
      title: 'Tea and food and flowers'
    },
    {
      id: '114',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FTea_in_the_Garden.jpg?alt=media',
      title: 'Tea in the Garden'
    },
    {
      id: '138',
      category: IC.TP,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FTeddy_Bear_Tea.jpg?alt=media',
      title: 'Teddy Bear Tea'
    },
    {
      id: '139',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FBeautiful_Buffet_Brunch.jpg?alt=media',
      title: 'Beautiful Buffet Brunch'
    },
    {
      id: '115',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FFlowers_and_Rings.jpg?alt=media',
      title: 'Flowers and Rings'
    },
    {
      id: '116',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FPath_of_Roses.jpg?alt=media',
      title: 'Path of Roses'
    },
    {
      id: '117',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSay_Yes_to_the_Dress.jpg?alt=media',
      title: 'Say Yes to the Dress'
    },
    {
      id: '118',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FSunny_Champagne.jpg?alt=media',
      title: 'Sunny Champagne'
    },
    {
      id: '119',
      category: IC.WD,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FWedding_Rings.jpg?alt=media',
      title: 'Wedding Rings'
    },
    {
      id: '120',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FArt___Wine.jpg?alt=media',
      title: 'Art & Wine'
    },
    {
      id: '140',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FCrush_Party.jpg?alt=media',
      title: 'Crush Party'
    },
    {
      id: '141',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FEverybody_Loves_Lucy.jpg?alt=media',
      title: 'Everybody Loves Lucy'
    },
    {
      id: '121',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRainbow_of_Tastes.jpg?alt=media',
      title: 'Rainbow of Tastes'
    },
    {
      id: '122',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FRenaissance_Wine_Tasting.jpg?alt=media',
      title: 'Renaissance Wine Tasting'
    },
    {
      id: '123',
      category: IC.WT,
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/elk-ga/o/events%2Finspirations%2FWine_Tasting.jpg?alt=media',
      title: 'Wine Tasting'
    }
  ]
;

export const InspirationsByType: Map<InspirationCategory, InspirationIdea[]> = new Map();

for (const inspiration of Inspirations) {
  if (!InspirationsByType.has(inspiration.category)) {
    InspirationsByType.set(inspiration.category, []);
  }
  InspirationsByType.get(inspiration.category)?.push(inspiration);
}

export default Inspirations;
